var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useMemo, useRef } from 'react';
import { C } from '#integrations';
import { mergeAriaIds } from '#services';
import { Typography } from '../../Typography';
import { TextInput } from '../TextInput';
import { ListBoxOption } from './components/ListBoxOption';
import { ListBoxTestIdFactory } from './interactions/ListBox.interactions';
import { LISTBOX_OTHER_OPTION_ID } from './ListBox.constants';
import { deriveOtherFieldValue } from './ListBox.services';
import { useListBox } from './useListBox';
import styles from './ListBox.module.css';
const ALIGNMENT_CLASS_MAP = {
    start: styles.ListBoxAlignStart,
    center: styles.ListBoxAlignCenter,
    end: styles.ListBoxAlignEnd,
};
export const ListBox = ({ align = 'center', 'aria-errormessage': ariaErrorMessage, 'aria-invalid': ariaInvalid, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'data-testid': testId, disabled = false, inputAriaLabel, isSingleSelect = true, label, onBlur, onChange, onFocus, options, placeholder, ref, required, value = [], }) => {
    _react_refresh_temp_2();
    const containerRef = useRef(null);
    const labelId = useId();
    const { getTabIndex, handleKeyDown, handleOtherFieldChange, listBoxValue, optionRefs, toggleOption, } = useListBox({
        options,
        value,
        disabled,
        isSingleSelect,
        onChange,
    });
    const otherFieldValue = useMemo(() => deriveOtherFieldValue({ listBoxValue, options }), [options, listBoxValue]);
    const handleFocusIn = (event) => {
        const target = event.relatedTarget;
        const currentTarget = event.currentTarget;
        if (!target || !currentTarget.contains(target)) {
            onFocus?.(event);
        }
    };
    const handleFocusOut = (event) => {
        if (containerRef.current &&
            !containerRef.current.contains(event.relatedTarget)) {
            onBlur?.(event);
        }
    };
    const hasOtherFieldValue = otherFieldValue || otherFieldValue === '';
    return (_jsxs("div", { className: C(styles.Container), "data-testid": ListBoxTestIdFactory.getListBoxContainerTestId(testId), onBlur: handleFocusOut, onFocus: handleFocusIn, ref: containerRef, children: [Boolean(label) && (_jsx(Typography, { className: styles.Label, color: "accent", "data-testid": ListBoxTestIdFactory.getListBoxLabelTestId(testId), id: labelId, kind: "label", children: label })), _jsx("div", { "aria-disabled": disabled, "aria-errormessage": ariaErrorMessage, "aria-invalid": ariaInvalid, "aria-label": ariaLabel, "aria-labelledby": mergeAriaIds(label ? labelId : undefined, ariaLabelledBy), "aria-multiselectable": !isSingleSelect, ...(required && { 'aria-required': true }), className: C(styles.ListBox, ALIGNMENT_CLASS_MAP[align], disabled && styles.ListBoxDisabled), "data-testid": ListBoxTestIdFactory.getListBoxTestId(testId), onKeyDown: handleKeyDown, role: "listbox", children: options.map((option, index) => {
                    const isSelected = listBoxValue.includes(option.id) ||
                        Boolean(option.id === LISTBOX_OTHER_OPTION_ID &&
                            hasOtherFieldValue);
                    const tabIndex = getTabIndex(option.id, index);
                    return (_jsx(ListBoxOption, { "data-testid": ListBoxTestIdFactory.getListBoxOptionTestId(testId, option.id), disabled: disabled || option.disabled, isSelected: isSelected, onClick: () => toggleOption(option.id), option: option, ref: (el) => {
                            // Focusing the list lands where Tab would
                            if (ref && tabIndex === 0) {
                                ref.current = el;
                            }
                            optionRefs.current[index] = el;
                        }, tabIndex: tabIndex }, option.id));
                }) }), hasOtherFieldValue && (_jsx("div", { className: styles.OtherFieldContainer, children: _jsx(TextInput, { "aria-label": inputAriaLabel, "data-testid": ListBoxTestIdFactory.getListBoxOtherFieldTestId(testId), disabled: disabled, onChange: handleOtherFieldChange, placeholder: placeholder, value: otherFieldValue }) }))] }));
};
_react_refresh_temp_1 = ListBox;
$RefreshReg$(_react_refresh_temp_1, "ListBox");
_react_refresh_temp_2(ListBox, "lBejFiBar1AHP9VMt+AFTOH9+Hg=", false, () => [useListBox]);
